module.exports = __webpack_public_path__ + "static/media/empty_search.bd338924.png";